const DEFAULT_API_BASE = "https://defi-analytics.impactgena2.workers.dev";

const getApiBase = () => process.env.REACT_APP_ANALYTICS_API || DEFAULT_API_BASE;

const fetchJson = async (path, params = {}) => {
  const url = new URL(path, getApiBase());
  const searchParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === "") return;
    searchParams.set(key, String(value));
  });
  const query = searchParams.toString();
  if (query) {
    url.search = query;
  }

  const response = await fetch(url.toString(), { method: "GET" });
  const payload = await response.json().catch(() => null);
  if (!response.ok || !payload || payload.ok === false) {
    const message = payload?.error || `Request failed (${response.status})`;
    throw new Error(message);
  }
  return payload;
};

export const fetchEntities = async () => {
  const payload = await fetchJson("/entities");
  return payload.entities || [];
};

export const fetchSeries = async ({ period = "hour", limit = 2000, order = "asc", entityId, metric, startTs, endTs } = {}) => {
  const payload = await fetchJson("/analytics/series", {
    period,
    limit,
    order,
    entity_id: entityId,
    metric,
    start_ts: startTs,
    end_ts: endTs
  });
  return payload.series || [];
};

export const getApiInfo = () => ({
  baseUrl: getApiBase()
});
